'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

require('antd/lib/button/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _typeConfig = require('./typeConfig');

var _typeConfig2 = _interopRequireDefault(_typeConfig);

var _index = require('./index.less');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Exception = function Exception(_ref) {
  var className = _ref.className,
      _ref$linkElement = _ref.linkElement,
      linkElement = _ref$linkElement === undefined ? 'a' : _ref$linkElement,
      type = _ref.type,
      title = _ref.title,
      desc = _ref.desc,
      img = _ref.img,
      actions = _ref.actions,
      rest = _objectWithoutProperties(_ref, ['className', 'linkElement', 'type', 'title', 'desc', 'img', 'actions']);

  var pageType = type in _typeConfig2.default ? type : '404';
  var clsString = (0, _classnames2.default)(_index2.default.exception, className);
  return _react2.default.createElement(
    'div',
    Object.assign({ className: clsString }, rest),
    _react2.default.createElement(
      'div',
      { className: _index2.default.imgBlock },
      _react2.default.createElement('div', {
        className: _index2.default.imgEle,
        style: { backgroundImage: 'url(' + (img || _typeConfig2.default[pageType].img) + ')' }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: _index2.default.content },
      _react2.default.createElement(
        'h1',
        null,
        title || _typeConfig2.default[pageType].title
      ),
      _react2.default.createElement(
        'div',
        { className: _index2.default.desc },
        desc || _typeConfig2.default[pageType].desc
      ),
      _react2.default.createElement(
        'div',
        { className: _index2.default.actions },
        actions || (0, _react.createElement)(linkElement, {
          to: '/',
          href: '/'
        }, _react2.default.createElement(
          _button2.default,
          { type: 'primary' },
          '\u041D\u04AF\u04AF\u0440 \u0445\u0443\u0443\u0434\u0430\u0441 \u0440\u0443\u0443 \u0431\u0443\u0446\u0430\u0445'
        ))
      )
    )
  );
};

Exception.defaultProps = {
  actions: undefined,
  img: undefined,
  desc: undefined,
  title: undefined,
  type: undefined,
  className: undefined,
  linkElement: undefined,
  copyright: undefined
};

Exception.propTypes = {
  actions: _propTypes2.default.node,
  img: _propTypes2.default.string,
  desc: _propTypes2.default.string,
  title: _propTypes2.default.string,
  type: _propTypes2.default.string,
  className: _propTypes2.default.string,
  linkElement: _propTypes2.default.func,
  copyright: _propTypes2.default.string
};

exports.default = Exception;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Exception/index.js
// module id = 769
// module chunks = 0